import { BaseService } from "./base.service";
import { IEftModule } from "models/EftModuleModel";

class EftModuleServiceInternal extends BaseService {
	getEftModuleList = async (): Promise<IEftModule[]> =>
		this.callApi<IEftModule[]>(
			`EftModule/GetEftModuleList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			false
		);
}

export const EftModuleService = new EftModuleServiceInternal();
